export const enum Inputs {
  "name" = "name",
  "phone" = "phone",
  "email" = "email",
  "cvlink" = "cvlink",
}
